/* Polished 3D Prints — shared storefront behaviour (2026-10, round 2 video fixes)
   1. Estimated arrival dates   (#9)
   2. Slide-out cart drawer     (#15, #20 quick-add)
   3. Color guide pop-up        (#16)
   4. Product photo swipe, arrows and zoom lightbox (#6)
*/
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var TEMPLATE = document.body.getAttribute('data-template') || '';
  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function lock(on) { document.documentElement.classList.toggle('p3d-lock', !!on); }

  /* ---------------------------------------------------------------
     1. Estimated arrival
     data-min / data-max are business days from today (make time + USPS Priority transit).
     Weekends and USPS holidays are skipped.
  --------------------------------------------------------------- */
  var HOLIDAYS = ['2026-11-11', '2026-11-26', '2026-12-25', '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31',
    '2027-06-18', '2027-07-05', '2027-09-06', '2027-10-11', '2027-11-11', '2027-11-25', '2027-12-24', '2027-12-31'];
  function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function addBusinessDays(n) {
    var d = new Date(); d.setHours(12, 0, 0, 0);
    var c = 0;
    while (c < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w === 0 || w === 6 || HOLIDAYS.indexOf(iso(d)) > -1) continue;
      c++;
    }
    return d;
  }
  function fmtRange(a, b) {
    var mA = a.toLocaleDateString('en-US', { month: 'short' }), mB = b.toLocaleDateString('en-US', { month: 'short' });
    if (a.getTime() === b.getTime()) return mA + ' ' + a.getDate();
    if (a.getMonth() === b.getMonth()) return mA + ' ' + a.getDate() + '–' + b.getDate();
    return mA + ' ' + a.getDate() + ' – ' + mB + ' ' + b.getDate();
  }
  function renderEta(root) {
    $$('[data-p3d-eta]', root).forEach(function (el) {
      var mn = parseInt(el.getAttribute('data-min'), 10), mx = parseInt(el.getAttribute('data-max'), 10);
      if (!(mn > 0) || !(mx >= mn)) return;
      var t = $('[data-p3d-eta-text]', el);
      if (t) t.textContent = 'Arrives ' + fmtRange(addBusinessDays(mn), addBusinessDays(mx));
    });
  }
  renderEta(document);

  /* ---------------------------------------------------------------
     2. Cart drawer
  --------------------------------------------------------------- */
  var drawer = $('[data-p3d-drawer]');
  var panel = drawer && $('.p3d-drawer-panel', drawer);
  var lastFocus = null, closeTimer = null;

  function setCount(n) {
    $$('.p3d-cart-link').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + n + ' items');
      var s = $('[data-p3d-cart-count]', a);
      if (n > 0) {
        if (!s) {
          s = document.createElement('span');
          s.className = 'p3d-cart-count';
          s.setAttribute('data-p3d-cart-count', '');
          a.appendChild(s);
        }
        s.textContent = n;
      } else if (s) { s.parentNode.removeChild(s); }
    });
  }

  function openDrawer() {
    if (!drawer) return;
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    drawer.hidden = false;
    // force layout so the slide-in transition runs
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    lock(true);
    try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    lock(false);
    closeTimer = setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function refreshDrawer(addedText) {
    if (!drawer) return Promise.resolve();
    return fetch(ROOT + '?sections=cart-drawer', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-p3d-drawer-body]', doc), cur = $('[data-p3d-drawer-body]', drawer);
        if (!fresh || !cur) return;
        cur.innerHTML = fresh.innerHTML;
        setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
        renderEta(drawer);
        if (addedText) {
          var a = $('[data-p3d-drawer-added]', drawer);
          if (a) { a.textContent = addedText; a.hidden = false; }
        }
      });
  }

  // Leave out line-item properties left blank (e.g. a part kept "As pictured"), so orders don't
  // carry empty lines.
  function cleanForm(form) {
    var fd = new FormData(form), out = new FormData();
    fd.forEach(function (v, k) {
      if (/^properties\[/.test(k) && typeof v === 'string' && !v.trim()) return;
      out.append(k, v);
    });
    return out;
  }
  function addToCart(form) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: cleanForm(form)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Could not add this item.');
        return j;
      });
    });
  }

  function addedLabel(item) {
    if (!item) return 'Added to your cart';
    var name = (item.product_title || item.title || '').split(': ')[0].split(' — ')[0];
    return '✓ Added: ' + name;
  }

  function showFormError(form, msg) {
    var e = $('.p3d-add-error', form);
    if (!e) { e = document.createElement('p'); e.className = 'p3d-add-error'; e.setAttribute('role', 'alert'); form.appendChild(e); }
    e.textContent = msg;
  }

  if (drawer) {
    // Product page "Add to cart" opens the drawer instead of jumping to /cart.
    $$('[data-p3d-product] form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (ev) {
        if (form.checkValidity && !form.checkValidity()) return;
        ev.preventDefault();
        var btn = $('[data-p3d-add]', form) || $('button[type="submit"]', form);
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        var old = $('.p3d-add-error', form); if (old) old.textContent = '';
        addToCart(form)
          .then(function (item) { return refreshDrawer(addedLabel(item)).then(openDrawer); })
          .catch(function (err) { showFormError(form, err.message); })
          .then(function () { if (btn) { btn.disabled = false; btn.textContent = label && label.indexOf('Adding') < 0 ? label : 'Add to cart'; } });
      });
    });

    // Header cart links open the drawer (except on the cart page itself).
    if (TEMPLATE !== 'cart') {
      $$('.p3d-cart-link').forEach(function (a) {
        a.addEventListener('click', function (ev) {
          if (ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
          ev.preventDefault();
          openDrawer();
          refreshDrawer();
        });
      });
    }

    drawer.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-p3d-drawer-close]')) { closeDrawer(); return; }
      var step = ev.target.closest('[data-p3d-qty-step]');
      var rem = ev.target.closest('[data-p3d-remove]');
      if (!step && !rem) return;
      var li = ev.target.closest('[data-line-key]');
      if (!li) return;
      var qtyEl = $('.p3d-stepper span', li);
      var qty = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
      var next = rem ? 0 : Math.max(0, qty + parseInt(step.getAttribute('data-p3d-qty-step'), 10));
      li.classList.add('is-busy');
      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: li.getAttribute('data-line-key'), quantity: next })
      }).then(function () { return refreshDrawer(); })
        .catch(function () { li.classList.remove('is-busy'); });
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
    });
  }

  // Any product form that still submits normally: drop blank property fields first.
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var off = $$('[name^="properties["]', f).filter(function (el) { return !el.disabled && !String(el.value || '').trim(); });
    off.forEach(function (el) { el.disabled = true; });
    // The browser reads the form during this event; switch the fields back on straight after.
    setTimeout(function () { off.forEach(function (el) { el.disabled = false; }); }, 0);
  }, true);

  // "Complete your gift" quick-add (drawer and cart page).
  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest && ev.target.closest('form[data-p3d-quick-add]');
    if (!form) return;
    ev.preventDefault();
    var btn = $('button', form);
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    addToCart(form).then(function (item) {
      if (TEMPLATE === 'cart') { window.location.reload(); return; }
      return refreshDrawer(addedLabel(item)).then(function () { if (drawer && drawer.hidden) openDrawer(); });
    }).catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Add'; }
      showFormError(form, err.message);
    });
  });

  /* ---------------------------------------------------------------
     2b. Discount codes (cart page + drawer)
     Uses the Cart AJAX API: POST /cart/update.js {discount: "A,B"} replaces the
     cart's codes; the response lists each code with applicable true/false.
  --------------------------------------------------------------- */
  function appliedCodes(box) {
    return $$('[data-p3d-discount-code]', box).map(function (li) { return li.getAttribute('data-p3d-discount-code'); });
  }
  function setCodes(codes) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }
  function afterDiscount() {
    if (TEMPLATE === 'cart') { window.location.reload(); return Promise.resolve(); }
    return refreshDrawer();
  }
  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest && ev.target.closest('form[data-p3d-discount-form]');
    if (!form) return;
    ev.preventDefault();
    var box = form.closest('[data-p3d-discount]');
    var input = $('[data-p3d-discount-input]', form), msg = $('[data-p3d-discount-msg]', form), btn = $('button', form);
    var code = (input.value || '').trim();
    if (!code) { msg.textContent = 'Type a code first.'; msg.className = 'p3d-discount-msg is-error'; input.focus(); return; }
    var have = appliedCodes(box);
    if (have.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { msg.textContent = 'That code is already applied.'; msg.className = 'p3d-discount-msg'; return; }
    btn.disabled = true; btn.textContent = 'Checking…'; msg.textContent = '';
    setCodes(have.concat([code])).then(function (cart) {
      var hit = (cart.discount_codes || []).filter(function (d) { return (d.code || '').toLowerCase() === code.toLowerCase(); })[0];
      if (hit && hit.applicable) {
        msg.textContent = '✓ ' + hit.code + ' applied'; msg.className = 'p3d-discount-msg is-ok';
        return afterDiscount();
      }
      // Not valid for this cart: put the cart back the way it was.
      return setCodes(have).then(function () {
        msg.textContent = '“' + code + '” isn’t valid for this cart. Check the spelling, or the minimum order it needs.';
        msg.className = 'p3d-discount-msg is-error';
      });
    }).catch(function () {
      msg.textContent = 'Couldn’t check that code. Try again, or enter it at checkout.'; msg.className = 'p3d-discount-msg is-error';
    }).then(function () { btn.disabled = false; btn.textContent = 'Apply'; });
  });
  document.addEventListener('click', function (ev) {
    var rm = ev.target.closest && ev.target.closest('[data-p3d-discount-remove]');
    if (!rm) return;
    var box = rm.closest('[data-p3d-discount]'), li = rm.closest('[data-p3d-discount-code]');
    var gone = li.getAttribute('data-p3d-discount-code');
    rm.disabled = true;
    setCodes(appliedCodes(box).filter(function (c) { return c !== gone; })).then(afterDiscount)
      .catch(function () { rm.disabled = false; });
  });

  /* ---------------------------------------------------------------
     3. Color guide pop-up
  --------------------------------------------------------------- */
  var modal = null, modalLoaded = false;
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'p3d-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="p3d-modal-scrim" data-p3d-modal-close></div>' +
      '<div class="p3d-modal-card" role="dialog" aria-modal="true" aria-labelledby="P3dColorsTitle" tabindex="-1">' +
        '<div class="p3d-modal-head"><h2 id="P3dColorsTitle">Color guide</h2>' +
        '<button type="button" class="p3d-drawer-x" data-p3d-modal-close aria-label="Close color guide">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
        '<p class="p3d-modal-hint" data-p3d-modal-hint hidden>Tap a color to choose it for this piece. Faded colors aren’t offered for it.</p>' +
        '<div class="p3d-modal-content" data-p3d-modal-content><p class="p3d-modal-loading">Loading colors…</p></div>' +
        '<p class="p3d-modal-foot"><a href="/pages/filament-colors">Open the full Colors page</a></p>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-p3d-modal-close]')) { closeModal(); return; }
      var fig = ev.target.closest('figure.sw.is-pickable');
      if (fig) pickColor(fig);
    });
    modal.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') closeModal();
      if ((ev.key === 'Enter' || ev.key === ' ') && ev.target.matches && ev.target.matches('figure.sw.is-pickable')) { ev.preventDefault(); pickColor(ev.target); }
    });
  }
  function productSwatch(name) {
    return $$('.p3d-swatch').filter(function (s) { return s.getAttribute('data-value') === name && !s.hidden; })[0] || null;
  }
  function markPickable() {
    var onProduct = $$('.p3d-swatch').length > 0;
    var hint = $('[data-p3d-modal-hint]', modal);
    if (hint) hint.hidden = !onProduct;
    $$('figure.sw', modal).forEach(function (fig) {
      fig.classList.remove('is-pickable', 'is-unavailable', 'is-current');
      fig.removeAttribute('tabindex'); fig.removeAttribute('role');
      if (!onProduct) return;
      var cap = $('figcaption', fig), name = cap ? cap.textContent.trim() : '';
      var sw = productSwatch(name);
      if (sw) {
        fig.classList.add('is-pickable');
        fig.setAttribute('role', 'button');
        fig.setAttribute('tabindex', '0');
        fig.setAttribute('aria-label', 'Choose ' + name);
        if (sw.classList.contains('is-selected')) fig.classList.add('is-current');
      } else {
        fig.classList.add('is-unavailable');
      }
    });
  }
  function pickColor(fig) {
    var cap = $('figcaption', fig), sw = productSwatch(cap ? cap.textContent.trim() : '');
    if (sw) sw.click();
    closeModal();
    if (sw) { try { sw.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {} }
  }
  function openModal(href) {
    if (!modal) buildModal();
    modal.hidden = false;
    void modal.offsetWidth;
    modal.classList.add('is-open');
    lock(true);
    var card = $('.p3d-modal-card', modal);
    try { card.focus({ preventScroll: true }); } catch (e) {}
    if (modalLoaded) { markPickable(); return; }
    fetch(href || '/pages/filament-colors', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = $('.p3d-colors', doc);
        if (!body) throw 0;
        var styles = $$('#MainContent style', doc).map(function (s) { return s.outerHTML; }).join('');
        $('[data-p3d-modal-content]', modal).innerHTML = body.outerHTML + styles;
        modalLoaded = true;
        markPickable();
      })
      .catch(function () { window.location.href = href || '/pages/filament-colors'; });
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    lock(false);
    setTimeout(function () { modal.hidden = true; }, 200);
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[data-p3d-colors]');
    if (!a || ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
    ev.preventDefault();
    openModal(a.getAttribute('href'));
  });

  /* ---------------------------------------------------------------
     4. Product gallery: arrows, swipe, zoom lightbox
  --------------------------------------------------------------- */
  $$('[data-p3d-gallery]').forEach(function (gallery) {
    var stage = $('.p3d-gallery-stage', gallery);
    if (!stage) return;
    var thumbs = $$('.p3d-thumb', gallery);

    function visibleThumbs() { return thumbs.filter(function (t) { return t.style.display !== 'none'; }); }
    function activeMedia() { return $('.p3d-media.is-active', stage); }
    function go(dir) {
      var list = visibleThumbs();
      if (list.length < 2) return;
      var cur = activeMedia(), id = cur && cur.getAttribute('data-media-id');
      var i = -1;
      list.forEach(function (t, k) { if (t.getAttribute('data-media-target') === id) i = k; });
      i = i < 0 ? 0 : (i + dir + list.length) % list.length;
      list[i].click();
      try { list[i].scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
    }

    // Arrows (only when there is more than one photo to move between)
    if (visibleThumbs().length > 1) {
      ['prev', 'next'].forEach(function (k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'p3d-stage-nav is-' + k;
        b.setAttribute('aria-label', k === 'prev' ? 'Previous photo' : 'Next photo');
        b.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (k === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
        b.addEventListener('click', function (ev) { ev.stopPropagation(); go(k === 'prev' ? -1 : 1); });
        stage.appendChild(b);
      });
    }
    var zb = document.createElement('button');
    zb.type = 'button';
    zb.className = 'p3d-stage-zoom';
    zb.setAttribute('aria-label', 'Zoom photo');
    zb.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4M11 8v6M8 11h6"/></svg><span>Zoom</span>';
    zb.addEventListener('click', function (ev) { ev.stopPropagation(); openLightbox(); });
    stage.appendChild(zb);

    function syncZoomButton() {
      var m = activeMedia(), rc = $('.p3d-recolor.is-on', stage);
      var isImg = !!rc || !!(m && $('img', m) && !$('video, model-viewer, iframe', m));
      zb.hidden = !isImg;
    }
    new MutationObserver(syncZoomButton).observe(stage, { attributes: true, subtree: true, attributeFilter: ['class'] });
    syncZoomButton();

    // Swipe (touch) and click-to-zoom on the main photo
    var sx = 0, sy = 0, moved = false, tracking = false;
    stage.addEventListener('pointerdown', function (ev) {
      if (ev.target.closest('video, model-viewer, iframe')) { tracking = false; return; }
      tracking = true; moved = false; sx = ev.clientX; sy = ev.clientY;
    });
    stage.addEventListener('pointermove', function (ev) {
      if (tracking && (Math.abs(ev.clientX - sx) > 8 || Math.abs(ev.clientY - sy) > 8)) moved = true;
    });
    stage.addEventListener('pointerup', function (ev) {
      if (!tracking) return;
      tracking = false;
      var dx = ev.clientX - sx, dy = ev.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) { go(dx < 0 ? 1 : -1); moved = true; }
    });
    stage.addEventListener('pointercancel', function () { tracking = false; });
    // Stop the browser's own image drag from swallowing a mouse swipe
    stage.addEventListener('dragstart', function (ev) { if (ev.target.tagName === 'IMG') ev.preventDefault(); });
    // Touch: let vertical scrolling through, catch horizontal swipes
    stage.style.touchAction = 'pan-y pinch-zoom';
    stage.addEventListener('click', function (ev) {
      if (moved) { moved = false; return; }
      if (ev.target.closest('video, model-viewer, iframe, button')) return;
      if (!zb.hidden) openLightbox();
    });

    // ---- Lightbox ----
    var lb = null, slides = [], idx = 0, zoomed = false;
    function collectSlides() {
      var out = [], startId = null;
      var rcOn = $('.p3d-recolor.is-on', stage), rcImg = rcOn && $('img', rcOn), rcNote = rcOn && $('.p3d-recolor-note', rcOn);
      if (rcImg && rcImg.src) out.push({ src: rcImg.src, alt: 'Color preview', label: rcNote ? rcNote.textContent : 'Color preview', id: '__rc' });
      var cur = activeMedia(); startId = rcImg ? '__rc' : (cur && cur.getAttribute('data-media-id'));
      var ids = visibleThumbs().map(function (t) { return t.getAttribute('data-media-target'); });
      if (!thumbs.length && cur) ids = [cur.getAttribute('data-media-id')];
      if (cur && ids.indexOf(cur.getAttribute('data-media-id')) < 0) ids.unshift(cur.getAttribute('data-media-id'));
      ids.forEach(function (id) {
        var m = $('.p3d-media[data-media-id="' + id + '"]', stage);
        var img = m && !$('video, model-viewer, iframe', m) && $('img', m);
        if (img) out.push({ src: img.getAttribute('data-zoom-src') || img.currentSrc || img.src, alt: img.alt || '', id: id });
      });
      var start = 0;
      out.forEach(function (s, k) { if (s.id === startId) start = k; });
      return { list: out, start: start };
    }
    function buildLightbox() {
      lb = document.createElement('div');
      lb.className = 'p3d-lb';
      lb.hidden = true;
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Photo viewer');
      lb.innerHTML =
        '<div class="p3d-lb-stage"><img class="p3d-lb-img" alt="" draggable="false"></div>' +
        '<button type="button" class="p3d-lb-btn is-close" aria-label="Close photo viewer"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<button type="button" class="p3d-lb-btn is-prev" aria-label="Previous photo"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button type="button" class="p3d-lb-btn is-next" aria-label="Next photo"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
        '<div class="p3d-lb-bar"><span class="p3d-lb-count" aria-live="polite"></span><span class="p3d-lb-tip">Tap the photo to zoom in</span></div>';
      document.body.appendChild(lb);
      var img = $('.p3d-lb-img', lb), st = $('.p3d-lb-stage', lb);
      $('.is-close', lb).addEventListener('click', closeLightbox);
      $('.is-prev', lb).addEventListener('click', function () { show(idx - 1); });
      $('.is-next', lb).addEventListener('click', function () { show(idx + 1); });
      document.addEventListener('keydown', function (ev) {
        if (!lb || lb.hidden) return;
        if (ev.key === 'Escape') closeLightbox();
        else if (ev.key === 'ArrowLeft') show(idx - 1);
        else if (ev.key === 'ArrowRight') show(idx + 1);
      });
      // Pointer handling: tap toggles zoom, drag pans when zoomed, swipe changes photo when not.
      var px = 0, py = 0, ox = 50, oy = 50, sox = 50, soy = 50, down = false, dragged = false;
      function setOrigin(x, y) {
        ox = Math.max(0, Math.min(100, x)); oy = Math.max(0, Math.min(100, y));
        img.style.transformOrigin = ox + '% ' + oy + '%';
      }
      st.style.touchAction = 'none';
      st.addEventListener('pointerdown', function (ev) {
        down = true; dragged = false; px = ev.clientX; py = ev.clientY; sox = ox; soy = oy;
        try { st.setPointerCapture(ev.pointerId); } catch (e) {}
      });
      st.addEventListener('pointermove', function (ev) {
        var r = img.getBoundingClientRect();
        if (zoomed && ev.pointerType === 'mouse' && !down) {
          setOrigin((ev.clientX - r.left) / r.width * 100, (ev.clientY - r.top) / r.height * 100);
          return;
        }
        if (!down) return;
        var dx = ev.clientX - px, dy = ev.clientY - py;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) dragged = true;
        if (zoomed && dragged) {
          var w = r.width || 1, h = r.height || 1;
          setOrigin(sox - dx / w * 100 * 1.6, soy - dy / h * 100 * 1.6);
        }
      });
      st.addEventListener('pointerup', function (ev) {
        if (!down) return;
        down = false;
        var dx = ev.clientX - px, dy = ev.clientY - py;
        if (!zoomed && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) { show(idx + (dx < 0 ? 1 : -1)); return; }
        if (!dragged) {
          var r = img.getBoundingClientRect();
          var onImg = ev.clientX >= r.left && ev.clientX <= r.right && ev.clientY >= r.top && ev.clientY <= r.bottom;
          if (!onImg) { if (!zoomed) closeLightbox(); else setZoom(false); return; }
          if (!zoomed) setOrigin((ev.clientX - r.left) / r.width * 100, (ev.clientY - r.top) / r.height * 100);
          setZoom(!zoomed);
        }
      });
      st.addEventListener('pointercancel', function () { down = false; });
    }
    function setZoom(on) {
      zoomed = on;
      lb.classList.toggle('is-zoomed', on);
      var tip = $('.p3d-lb-tip', lb);
      if (tip) tip.textContent = on ? 'Drag to look around · tap to zoom out' : 'Tap the photo to zoom in';
    }
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      var s = slides[idx], img = $('.p3d-lb-img', lb);
      setZoom(false);
      img.style.transformOrigin = '50% 50%';
      img.src = s.src;
      img.alt = s.alt;
      $('.p3d-lb-count', lb).textContent = (s.label ? s.label + ' · ' : '') + (idx + 1) + ' / ' + slides.length;
      var many = slides.length > 1;
      $('.is-prev', lb).hidden = !many;
      $('.is-next', lb).hidden = !many;
    }
    function openLightbox() {
      var c = collectSlides();
      if (!c.list.length) return;
      if (!lb) buildLightbox();
      slides = c.list;
      lb.hidden = false;
      void lb.offsetWidth;
      lb.classList.add('is-open');
      lock(true);
      show(c.start);
      try { $('.is-close', lb).focus({ preventScroll: true }); } catch (e) {}
    }
    function closeLightbox() {
      if (!lb || lb.hidden) return;
      lb.classList.remove('is-open');
      lock(false);
      setTimeout(function () { lb.hidden = true; }, 180);
      try { zb.focus({ preventScroll: true }); } catch (e) {}
    }
  });
})();
